/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateChangeRoundUpDestinationFlow} from '../api'

export const useMutationInitiateChangeRoundUpDestinationFlow = createReactQueryMutationHook('initiateChangeRoundUpDestinationFlow', initiateChangeRoundUpDestinationFlow)
